import React, { useState, useEffect } from 'react';
import {auth} from '../../app-firebase/firebase';
import LoggedAdmin from './LoggedAdmin';
import UnloggedAdmin from './UnloggedAdmin';
import ReactLoading from 'react-loading';
import $ from 'jquery'

import './admin.scss'


function Admin(props) {
   const [isLogged, setIsLogged] = useState(false);
   const [error, setError] = useState('');
   const [user, setuser] = useState(null);
   const [loading, setLoading] = useState(true);

   useEffect(() => { 
      $('footer').hide();
      setTimeout(() => {
         setLoading(false);
      }, 3000);

      return () => {
         $('footer').show();
         
      }
   });
   auth.onAuthStateChanged(firebaseUser => {
      if (firebaseUser) {
         setIsLogged(true);
         setuser(firebaseUser);
      } else {
         setIsLogged(false);
         setuser(null);
      }
   })

   const loadingLayer = (
      <div className="d-flex justify-content-center align-items-center" style={{height: '100vh !important'}}>
         <ReactLoading type="bubbles" color="#2d3142"/>
      </div>
   );
   
   return isLogged ? 
      <LoggedAdmin user={user} /> :
      loading ? loadingLayer : <UnloggedAdmin setIsLogged={setIsLogged} error={error} setError={setError}/>;
}



export default Admin;